<template>
  <div>
    <!-- 年月选择弹框 -->
    <el-dialog title="选择年月" :visible.sync="monthDialogVisible" width="30%">
      <el-date-picker v-model="selectedMonth" type="month" placeholder="请选择年月" format="yyyy-MM" value-format="yyyy-MM"
        style="width: 100%">
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button @click="monthDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleMonthConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <div class="title-en">搜索条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="150px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="业务工单号">
                <el-input v-model="searchForm.TicketId" placeholder="请输入业务工单号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="对账年月">
                <el-date-picker v-model="searchForm.Month" type="month" style="width: 100%" placeholder="请选择年月"
                  format="yyyy-MM" value-format="yyyy-MM">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工单是否超时">
                <el-select clearable v-model="searchForm.isDelayCause" placeholder="请选择">
                  <el-option label="是" :value="true"></el-option>
                  <el-option label="否" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="PO订单号">
                <el-input v-model="searchForm.orderNo" placeholder="请输入PO订单号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="PO分派单单号">
                <el-input v-model="searchForm.it_po_opTicketid" placeholder="请输入PO分派单单号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="PO计费单号">
                <el-input v-model="searchForm.cost_confirm_opTicketid" placeholder="请输入PO计费单号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="PO计费单状态">
                <el-select clearable v-model="searchForm.billState" placeholder="请选择">
                  <el-option label="全额" value="全额"></el-option>
                  <el-option label="7折" value="7折"></el-option>
                  <el-option label="不计费" value="不计费"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="结单人中文名">
                <el-input v-model="searchForm.engineerName" placeholder="请输入结单人中文名"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="自动核对状态">
                <el-select v-model="searchForm.autoCheckStatus" clearable placeholder="请选择自动核对状态" style="width: 100%">
                  <el-option label="正常" value="正常"></el-option>
                  <el-option label="异常" value="异常"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="手动核对状态">
                <el-select v-model="searchForm.manualCheckStatus" clearable placeholder="请选择手动核对状态" style="width: 100%">
                  <el-option label="正常" value="1"></el-option>
                  <el-option label="异常" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="确认结果">
                <el-select v-model="searchForm.confirm_result" clearable placeholder="请选择确认结果" style="width: 100%">
                  <el-option label="正常" value="正常"></el-option>
                  <el-option label="异常" value="异常"></el-option>
                  <el-option label="未确认" value="null"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="search-button">
                <el-button type="primary" @click="handleSearch">点击查询</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button @click="debouncedExport">{{ exportButtonText }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <div class="title-en">账单核对</div>

    <el-card class="box-card">
      <div class="table-container">
        <div class="button-container">
          <div>
            <el-button type="primary" @click="showMonthDialog('autoCheck')" :disabled="loading">自动核对</el-button>
            <el-button type="success" @click="showMonthDialog('batchDispatch')" :disabled="loading">派发已标记异常工单进行核对</el-button>
            <el-button type="danger" @click="showMonthDialog('returnToTencent')"
              :disabled="loading">对账信息返回腾讯</el-button>
          </div>
          <div><el-button @click="openColumnsDialog">表头设置</el-button></div>
        </div>
        <el-table :data="faults" border stripe @selection-change="handleSelectionChange" ref="table"
          v-loading="loading">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column v-for="(column, index) in visibleColumns" :key="index" :prop="column.prop"
            :label="column.label" :width="column.width" :header-style="{
              'white-space': 'normal',
              'word-break': 'break-all',
              height: 'auto',
              'line-height': '1.2',
              padding: '8px 0',
            }" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="column.prop === 'isDelayCause'">{{
                scope.row.isDelayCause == true ? '是' : '否'
              }}</span>
              <span v-else-if="column.prop === 'completeTime' || column.prop === 'billCompleteTime'">{{
                scope.row[column.prop]
                  ? $moment(scope.row[column.prop]).format('YYYY-MM-DD HH:mm:ss')
                  : ''
              }}</span>
              <span v-else-if="column.prop === 'cost_confirm_opTicketid'">
                <a :href="`https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=${scope.row.cost_confirm_opTicketid}&isHistory=1`
                  " target="_blank">{{ scope.row.cost_confirm_opTicketid || '-' }}</a>
              </span>
              <span v-else-if="column.prop === 'it_po_opTicketid'">
                <a :href="`https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=${scope.row.it_po_opTicketid}&isHistory=1`
                  " target="_blank">{{ scope.row.it_po_opTicketid || '-' }}</a>
              </span>
              <span v-else-if="column.prop === 'manualCheckTicket'">
                <a :href="scope.row.manualCheckStatus
                  ? `https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=${scope.row.manualCheckTicket}&isHistory=1`
                  : `https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=${scope.row.manualCheckTicket}`
                  " target="_blank">{{ scope.row.manualCheckTicket || '-' }}</a>
              </span>
              <el-tag v-else-if="column.prop === 'autoCheckStatus'"
                :type="scope.row[column.prop] === '正常' ? 'success' : scope.row[column.prop] === '异常' ? 'danger' : 'info'"
                size="mini">
                {{ scope.row[column.prop] || '未知' }}
              </el-tag>
              <el-tag v-else-if="column.prop === 'manualCheckStatus'"
                :type="scope.row[column.prop] === '1' ? 'success' : scope.row[column.prop] === '0' ? 'danger' : 'info'"
                size="mini">
                {{
                  scope.row[column.prop] === '0'
                    ? '异常'
                    : scope.row[column.prop] === '1'
                      ? '正常'
                      : '-'
                }}
              </el-tag>
              <el-tag v-else-if="column.prop === 'confirm_result'"
                :type="scope.row[column.prop] === '正常' ? 'success' : scope.row[column.prop] === '异常' ? 'danger' : 'warning'"
                size="mini">
                {{ scope.row[column.prop] || '未确认' }}
              </el-tag>
              <template v-else-if="column.prop === 'confirm_person'">
                <el-tag type="primary" size="mini" v-if="scope.row[column.prop]">
                  {{ scope.row[column.prop] }}
                </el-tag>
                <span v-else>-</span>
              </template>
              <span v-else>{{ scope.row[column.prop] || '-' }}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column label="操作" width="120" fixed="right" align="center">
            <template slot-scope="scope">
              <el-button
                style="margin-right: 20px"
                type="text"
                size="small"
                @click="debouncedSideOrders(scope.row, 0)"
                :disabled="scope.row.isDispatchCheck === '是'"
                >派单</el-button
              >
              <el-popover
                placement="top"
                width="200"
                trigger="click"
                popper-class="confirm-popover"
              >
                <div class="popover-content">
                  <el-button type="success" size="mini" @click="handleCheck(scope.row, '正常')"
                    >正常</el-button
                  >
                  <el-button type="danger" size="mini" @click="handleCheck(scope.row, '异常')"
                    >异常</el-button
                  >
                </div>
                <el-button
                  slot="reference"
                  type="text"
                  size="small"
                  :disabled="scope.row.confirm_person !== null && scope.row.confirm_result !== null"
                  >确认</el-button
                >
              </el-popover>
            </template>
          </el-table-column> -->

          <el-table-column label="操作" width="120" fixed="right" align="center">
            <template slot-scope="scope">
              <el-popover placement="top" width="200" trigger="click" popper-class="confirm-popover">
                <div class="popover-content">
                  <!-- <el-button type="success" size="mini" @click="handleCheck(scope.row, '正常')"
          >正常</el-button
        > -->
                  <el-button type="danger" size="mini" @click="handleCheck(scope.row, '异常')">异常</el-button>
                </div>
                <el-button slot="reference" type="text" size="small"
                  :disabled="scope.row.confirm_person !== null && scope.row.confirm_result !== null">
                  {{ scope.row.confirm_result === '异常' ? '已经标记异常' : '标记异常' }}
                </el-button>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog title="设置显示项" :visible.sync="showColumnsDialog" :append-to-body="true" width="600px"
          :close-on-click-modal="false" custom-class="columns-dialog" :modal-append-to-body="false"
          :destroy-on-close="true">
          <el-checkbox-group v-model="selectedColumns" class="checkbox-group">
            <el-checkbox v-for="column in columns" :key="column.prop" :label="column.prop" class="checkbox-item">
              {{ column.label }}
            </el-checkbox>
          </el-checkbox-group>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="selectAllColumns">全选</el-button>
            <el-button size="small" @click="restoreDefaultColumns">恢复默认</el-button>
            <el-button size="small" type="primary" @click="saveColumnsDialog">保存</el-button>
          </div>
        </el-dialog>

        <div class="pagination-container">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import {
  dispatchCheckTicket,
  getNetworkBillList,
  getNetworkBillListAll,
  confirmBill,
  autoCheckBill,
  submitCheckBillToTx,
} from '@/api/billApi';
import { getMachineList } from '@/api/workOrder';
import * as XLSX from 'xlsx';
import { debounce } from 'lodash';
export default {
  name: 'FaultList',
  data() {
    return {
      monthDialogVisible: false,
      selectedMonth: '',
      currentAction: '',
      debouncedExport: null,
      faults: [],
      searchForm: {
        TicketId: '',
        Month: this.$moment().subtract(1, 'month').format('YYYY-MM'),
        isDelayCause: '',
        orderNo: '',
        it_po_opTicketid: '',
        cost_confirm_opTicketid: '',
        billState: '',
        engineerName: '',
        autoCheckStatus: '',
        manualCheckStatus: '',
        confirm_result: '',
      },
      category_level_4Options: [
        { value: 1, label: '服务器' },
        { value: 2, label: '网络' },
        { value: 3, label: '资产' },
        { value: 4, label: '其它' },
        { value: 5, label: '人力' },
      ],
      campusNameOptions: [
        { value: '清远-清新', label: '清远-清新' },
        { value: '上海-临港', label: '上海-临港' },
        { value: '上海-书院', label: '上海-书院' },
        { value: '杭州-东冠', label: '杭州-东冠' },
        { value: '张家口-怀来东园', label: '怀来-东园' },
      ],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      showColumnsDialog: false,
      selectedColumns: [
        'opTicketid',
        'po_confirm',
        'ticketId_waitTodo',
        'order_level',
        'campusName',
        'createTime',
        'num',
        'realNum',
        'bill_type',
        'time_out',
        'check_status',
        'check_context',
        'memo',
        'result',
        'confirm_person',
      ],
      defaultSelectedColumns: [
        'TicketId',
        'completeTime',
        'Month',
        'isDelayCause',
        'orderNo',
        'it_po_opTicketid',
        'cost_confirm_opTicketid',
        'manualCheckTicket',
        'dispatchNum',
        'billNum',
        'changeBillNum',
        'billState',
        'billFactor',
        'billCompleteTime',
        'engineerName',
        'status',
        'ProcessDefinitionKey',
        'ticketType',
        'DCType',
        'bizAreaName',
        'confirm_person',
      ],
      selectedColumns: [
        'TicketId',
        'completeTime',
        'Month',
        'isDelayCause',
        'orderNo',
        'it_po_opTicketid',
        'cost_confirm_opTicketid',
        'manualCheckTicket',
        'dispatchNum',
        'billNum',
        'changeBillNum',
        'billState',
        'billFactor',
        'billCompleteTime',
        'engineerName',
        'status',
        'ProcessDefinitionKey',
        'ticketType',
        'DCType',
        'bizAreaName',
        'autoCheckStatus',
        'manualCheckStatus',
        'manualCheckStatus_memo',
        'confirm_result',

        'updateBillFactor',
        'manualCheckNum',
        'confirm_person',
      ],
      columns: [
        { prop: 'TicketId', label: '业务工单号', width: 150 },
        // { prop: 'completeTime', label: '工单结单时间', width: 160 },
        { prop: 'Month', label: '对账年月', width: 100 },
        // { prop: 'isDelayCause', label: '工单判断是否超时', width: 140 },
        { prop: 'autoCheckStatus', label: '自动核对状态', width: 100 },
        { prop: 'manualCheckStatus', label: '手工核对状态', width: 100 },
        { prop: 'manualCheckStatus_memo', label: '手动核对备注', width: 100 },
        { prop: 'updateBillFactor', label: '手动核对计费系数', width: 120 },
        { prop: 'manualCheckNum', label: '手动核对数量', width: 100 },
        { prop: 'confirm_result', label: '确认结果', width: 80 },
        { prop: 'confirm_person', label: '确认人', width: 90 },
        { prop: 'it_po_opTicketid', label: 'PO分派单单号', width: 150 },
        { prop: 'cost_confirm_opTicketid', label: 'PO计费单号', width: 150 },
        { prop: 'manualCheckTicket', label: '核对账单工单号', width: 150 },
        { prop: 'orderNo', label: 'PO订单号', width: 250 },
        { prop: 'dispatchNum', label: 'PO分派单数量', width: 120 },
        { prop: 'billNum', label: 'PO计费单数量', width: 120 },
        { prop: 'changeBillNum', label: '更新PO计费单数量', width: 150 },
        { prop: 'billState', label: 'PO计费单状态', width: 120 },
        { prop: 'billFactor', label: 'PO计费单系数', width: 120 },
        { prop: 'billCompleteTime', label: 'PO计费单结单时间', width: 160 },
        { prop: 'engineerName', label: '结单人中文名', width: 120 },
        // { prop: 'status', label: 'PO状态', width: 100 },
        { prop: 'SchemeNameCn', label: '网络流程名称', width: 120 },
        // { prop: 'ProcessDefinitionKey', label: '网络流程标识', width: 120 },
        { prop: 'bizAreaName', label: '一级机房', width: 120 },
        { prop: 'counts', label: '工单设备列表数量', width: 140 },
        { prop: 'completer', label: '结单人', width: 120 },
        { prop: 'createTime', label: '派单时间', width: 160 },
        { prop: 'finishTime', label: '工单完成时间', width: 160 },
        { prop: 'expectFinishTime', label: 'SLA', width: 160 },
        { prop: 'isTencentCause', label: '超时是否腾讯原因', width: 140 },
        { prop: 'delayCause', label: '超时原因', width: 120 },
        { prop: 'delayCausePic', label: '超时附件', width: 120 },
        { prop: 'checkCause', label: '工单判断超时原因', width: 140 },
        { prop: 'isChange', label: '工单是否变更', width: 120 },
        { prop: 'changeInfo', label: '工单变更值', width: 120 },
        { prop: 'isPo', label: '工单是否创建PO', width: 140 },
        { prop: 'isPeople', label: '自动/手工创建PO', width: 140 },
        { prop: 'dispatchFlowName', label: 'PO分派流程名', width: 140 },
        { prop: 'billFlowName', label: 'PO计费流程名', width: 140 },
        { prop: 'otType', label: 'PO计费项名称', width: 140 },
        { prop: 'dispatchCreateTime', label: 'PO单分派创建时间', width: 160 },
        { prop: 'dispatchDeskCreateTime', label: 'PO单分派服务台复核派单时间', width: 200 },
        { prop: 'dispatchServiceCreateTime', label: 'PO单分派服务商派单时间', width: 180 },
        { prop: 'isChangeBillNum', label: 'PO计费单数量是否变更', width: 160 },
        { prop: 'isChangeBillType', label: 'PO单类型是否变更', width: 140 },
        { prop: 'ChangeBillType', label: '更新PO计费项名称', width: 140 },
        { prop: 'billDeskChangeReason', label: 'PO计费服务台变更原因', width: 160 },
        { prop: 'billDeskChangeFile', label: 'PO计费服务台变更举证', width: 160 },
        { prop: 'billServiceChangeReason', label: 'PO计费服务商变更原因', width: 160 },
        { prop: 'billServiceChangeFile', label: 'PO计费服务商变更举证', width: 160 },
        { prop: 'deviceInfoNum', label: 'PO计费类型', width: 120 },
        // { prop: 'ticketType', label: '网络工单类型', width: 120 },
        // { prop: 'DCType', label: '机房类型', width: 100 },
        { prop: 'dispatchCompleteTime', label: '分派完成时间', width: 160 },
        { prop: 'dispatchDeskCompleteTime', label: 'PO单分派服务台复核结单时间', width: 200 },
        { prop: 'billCreateTime', label: 'PO计费单派单时间', width: 160 },
        { prop: 'isFieldForce', label: '是否驻场结单', width: 120 },
        { prop: 'cost_unit', label: '计费单位', width: 100 },
        { prop: 'is_desk', label: '是否经过服务台审核', width: 160 },
        { prop: 'deskChangeFile', label: '服务台审核举证', width: 140 },
        { prop: 'title', label: '工单标题', width: 200 },
        { prop: 'checkTicketId', label: '审核单号', width: 150 },
        { prop: 'opTicketid', label: '鸿云PO单号', width: 150 },
      ],
      visibleColumns: [],
      selectedRows: [],
      machineList: [],
      loading: false,
    };
  },
  created() {
    this.visibleColumns = this.columns.filter((column) =>
      this.selectedColumns.includes(column.prop)
    );
    this.searchForm.Month = this.$moment().subtract(1, 'month').format('YYYY-MM');
    this.fetchFaultData();
    // 创建防抖后的导出函数
    this.debouncedExport = debounce(this.handleExport, 300);
    // 创建防抖后的派单函数
    this.debouncedSideOrders = debounce(this.sideOrders, 300);
    this.debouncedSideOrdersBatch = debounce(this.sideOrdersBatch, 300);
    this.debouncedReturned = debounce(this.returned, 300);
  },
  methods: {
    showMonthDialog(action) {
      this.currentAction = action;
      this.monthDialogVisible = true;
    },

    handleMonthConfirm() {
      if (!this.selectedMonth) {
        this.$message.warning('请选择年月');
        return;
      }

      switch (this.currentAction) {
        case 'autoCheck':
          this.autoCheck(this.selectedMonth);
          break;
        case 'batchDispatch':
          this.debouncedSideOrdersBatch(this.selectedMonth, 1);
          break;
        case 'returnToTencent':
          this.debouncedReturned(this.selectedMonth);
          break;
      }

      this.monthDialogVisible = false;
      this.selectedMonth = '';
    },

    returned(month) {
      this.loading = true;
      let params = {
        Month: month,
      };
      submitCheckBillToTx(params)
        .then((res) => {
          if (res.data.data.code === 500) {
            this.$message.error(res.data.data.msg);
            this.loading = false;
            return;
          } else if (res.data.data.code === 204) {
            this.$message.warning(res.data.data.msg);
            this.loading = false;
            return;
          } else {
            this.$message.success(res.data.data.msg);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    async handleCheck(row, result) {
      try {
        const params = {
          orderNo: row.orderNo,
          confirm_person: localStorage.getItem('UserId'),
          confirm_result: result,
        };
        let res = await confirmBill(params);
        if (res.data.data.code === 200) {
          this.$message.success('标记成功');
          this.fetchFaultData();
        } else {
          this.$message.warning(res.data.data.msg);
        }
      } catch (error) {
        this.$message.error('确认失败：' + error.message);
      }
    },
    handleDateChange(dates) {
      if (dates) {
        this.searchForm.complete_start_date = dates[0];
        this.searchForm.complete_end_date = dates[1] + ' 23:59:59';
      } else {
        this.searchForm.complete_start_date = '';
        this.searchForm.complete_end_date = '';
      }
    },
    autoCheck(month) {
      this.loading = true;
      let params = {
        confirm_person: localStorage.getItem('UserId'),
        Month: month,
      };
      autoCheckBill(params)
        .then((res) => {
          if (res.data.data.code === 200) {
            this.loading = false;
            const data = res.data.data.data;
            if (data.lact_ticket_list.length > 0 || data.err_list.length > 0) {
              this.handleExportExcel(data);
            }
            if (data.lact_ticket_list.length > 0 || data.err_list.length > 0) {
              setTimeout(() => {
                this.$message({
                  type: 'success',
                  message: res.data.data.msg,
                  showClose: true,
                  duration: 0,
                });
              }, 2000);
            } else {
              this.$message({
                type: 'success',
                message: res.data.data.msg,
                showClose: true,
                duration: 0,
              });
            }

            this.handleSearch(); // 刷新列表
          } else {
            this.loading = false;
            this.$message({
              type: 'warning',
              message: res.data.data.msg || '自动核对失败',
              showClose: true,
              duration: 0,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.message);
        });
    },
    sideOrders(row, isBatch) {
      this.loading = true;
      const params = {
        batch_dispatch_check: isBatch,
        dispatch_manual_person: localStorage.getItem('UserId'),
      };

      if (!isBatch) {
        const fields = [
          'id',
          'TicketId_tx_bill',
          'Month',
          'SupplyName',
          'Assigner',
          'SchemeNameCn',
          'billFactor',
          'billNum',
          'counts',
          'dispatchNum',
          'orderNo',
          'engineerName',
          'autoCheckStatus',
        ];

        fields.forEach((field) => {
          if (row[field] !== undefined && row[field] !== null && row[field] !== '') {
            params[field] = row[field];
          }
        });
      }

      dispatchCheckTicket(params)
        .then((res) => {
          if (res.data.data.code === 200) {
            this.$message.success('派单成功');
            this.fetchFaultData();
            this.loading = false;
          } else if (res.data.data.code === 204) {
            this.$message({
              type: 'warning',
              message: res.data.data.msg || '派单失败',
              showClose: true,
              duration: 0,
            });
            this.loading = false;
          } else if (res.data.data.code === 500) {
            this.$message({
              type: 'error',
              message: res.data.data.msg || '操作失败',
              showClose: true,
              duration: 0,
            });
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error('派单失败：' + err.message);
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    sideOrdersBatch(month, isBatch) {
      this.loading = true;
      const params = {
        batch_dispatch_check: isBatch,
        dispatch_manual_person: localStorage.getItem('UserId'),
        Month: month,
      };

      if (!isBatch) {
        const fields = [
          'id',
          'TicketId_tx_bill',
          'Month',
          'SupplyName',
          'Assigner',
          'SchemeNameCn',
          'billFactor',
          'billNum',
          'counts',
          'dispatchNum',
          'orderNo',
          'engineerName',
        ];

        fields.forEach((field) => {
          if (row[field] !== undefined && row[field] !== null && row[field] !== '') {
            params[field] = row[field];
          }
        });
      }

      dispatchCheckTicket(params)
        .then((res) => {
          if (res.data.data.code === 200) {
            this.$message.success('派单成功');
            this.fetchFaultData();
            this.loading = false;
          } else if (res.data.data.code === 204) {
            this.$message({
              type: 'warning',
              message: res.data.data.msg || '派单失败',
              showClose: true,
              duration: 0,
            });
            this.loading = false;
          } else if (res.data.data.code === 500) {
            this.$message({
              type: 'error',
              message: res.data.data.msg || '派单失败',
              showClose: true,
              duration: 0,
            });
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error('派单失败：' + err.message);
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getMachineLists() {
      const params = {
        skip: this.currentPage,
        limit: this.pageSize,
      };
      getMachineList(params)
        .then((res) => {
          this.machineList = res.data.data.list || [];
        })
        .catch(() => {
          this.$message.error(errorMessage);
        });
    },
    async fetchFaultData() {
      const params = {
        skip: this.currentPage,
        limit: this.pageSize,
        TicketId: this.searchForm.TicketId,
        Month: this.searchForm.Month,
        isDelayCause: this.searchForm.isDelayCause,
        orderNo: this.searchForm.orderNo,
        it_po_opTicketid: this.searchForm.it_po_opTicketid,
        cost_confirm_opTicketid: this.searchForm.cost_confirm_opTicketid,
        billState: this.searchForm.billState,
        engineerName: this.searchForm.engineerName,
        autoCheckStatus: this.searchForm.autoCheckStatus,
        manualCheckStatus: this.searchForm.manualCheckStatus,
        confirm_result: this.searchForm.confirm_result,
      };
      // 过滤掉空值
      Object.keys(params).forEach((key) => {
        if (params[key] === '' || params[key] === null || params[key] === undefined) {
          delete params[key];
        }
      });
      this.loading = true;

      try {
        let response;
        // 使用常规的getNetworkBillList进行查询
        response = await getNetworkBillList(params);
        if (response.data) {
          let filteredData = response.data.data.list || [];
          this.faults = filteredData;
          this.total = response.data.data.total || 0;
        }
      } catch (error) {
        console.error('请求错误:', error);
        let errorMessage = '获取数据失败';
        if (error.response && error.response.status === 422) {
          errorMessage = '请求参数格式不正确，请检查输入';
        }
        this.$message.error(errorMessage);
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      // 处理PO标题前缀
      if (this.searchForm.memo && this.searchForm.memo.startsWith('PO确认单-')) {
        this.searchForm.memo = this.searchForm.memo.replace('PO确认单-', '');
      }
      this.currentPage = 1;
      this.fetchFaultData();
    },
    async handleExportExcel(data) {
      try {
        const XLSX = require('xlsx');
        const wb = XLSX.utils.book_new();

        // 设置表头中文映射
        const headerMap = {
          update_dict_toTX: '返回腾讯的异常数据预更新内容',
          orderNo: '工单号',
          expectFinishTime: '预计完成时间',
          changeInfo: '变更信息',
          cost_confirm_opTicketid: '结算单号',
          manualCheckTicket: '核对账单工单号',
          ChangeBillType: '变更单类型',
          ticketType: '工单类型',
          status: '状态',
          manualCheckStatus: '人工核对状态',
          updateOtType: '更新OT类型',
          TicketId: '工单ID',
          isTencentCause: '是否腾讯原因',
          isPo: '是否PO单',
          dispatchCreateTime: '派单创建时间',
          billState: '计费状态',
          DCType: 'DC类型',
          cost_unit: '计费单位',
          manualCheckStatus_memo: '人工核对备注',
          updateBillFactor: '更新计费系数',
          id: 'ID',
          bizAreaName: '业务区域',
          delayCause: '延期原因',
          isPeople: '是否人员',
          dispatchDeskCreateTime: '工作台派单创建时间',
          billFactor: '计费系数',
          dispatchCompleteTime: '派单完成时间',
          is_desk: '是否工作台',
          confirm_result: '确认结果',
          updateBillNum: '更新计费数量',
          Month: '月份',
          counts: '数量',
          delayCausePic: '延期原因图片',
          dispatchServiceCreateTime: '服务派单创建时间',
          dispatchNum: '派单数量',
          billDeskChangeReason: '工作台变更原因',
          dispatchDeskCompleteTime: '工作台派单完成时间',
          deskChangeFile: '工作台变更文件',
          updateBillFactor: '手动核对计费系数',
          manualCheckNum: '人工核对数量',
          updatePic: '更新图片',
          SupplyName: '供应商名称',
          TicketId_tx_bill: '腾讯结算单号',
          completer: '完成人',
          isDelayCause: '是否延期',
          dispatchFlowName: '派单流程名称',
          billNum: '计费数量',
          billDeskChangeFile: '工作台计费变更文件',
          billCreateTime: '结算单创建时间',
          title: '标题',
          confirm_person: '确认人',
          Assigner: '指派人',
          createTime: '创建时间',
          checkCause: '核对原因',
          billFlowName: '计费流程名称',
          isChangeBillNum: '是否变更计费数量',
          billServiceChangeReason: '服务计费变更原因',
          billCompleteTime: '结算单完成时间',
          checkTicketId: '核对工单ID',
          manualCheckTicket: '人工核对工单',
          SchemeNameCn: '方案名称',
          completeTime: '完成时间',
          isChange: '是否变更',
          otType: 'OT类型',
          changeBillNum: '变更计费数量',
          billServiceChangeFile: '服务计费变更文件',
          isFieldForce: '是否现场',
          opTicketid: '运维单号',
          dispatch_manual_person: '派单人工处理人',
          ProcessDefinitionKey: '流程定义键',
          finishTime: '结束时间',
          it_po_opTicketid: '派单号',
          isChangeBillType: '是否变更计费类型',
          deviceInfoNum: '设备信息数量',
          engineerName: '工程师姓名',
          autoCheckStatus: '自动核对状态',
          isDispatchCheck: '是否派单核对',
        };

        // 处理lact_ticket_list数据
        if (data.lact_ticket_list && data.lact_ticket_list.length > 0) {
          // 转换数据，添加中文表头
          const transformedData = data.lact_ticket_list.map((item) => {
            const newItem = {};
            Object.keys(headerMap).forEach((key) => {
              if (item[key] !== undefined) {
                // 特殊处理某些字段的显示
                if (key === 'manualCheckStatus') {
                  newItem[headerMap[key]] =
                    item[key] === '1' ? '正常' : item[key] === '0' ? '异常' : '-';
                } else if (key === 'autoCheckStatus') {
                  newItem[headerMap[key]] =
                    item[key] === '1' ? '正常' : item[key] === '0' ? '异常' : '-';
                } else if (key === 'confirm_result') {
                  newItem[headerMap[key]] =
                    item[key] === '1' ? '正常' : item[key] === '0' ? '异常' : '-';
                } else {
                  newItem[headerMap[key]] = item[key] || '-';
                }
              }
            });
            return newItem;
          });

          const ws = XLSX.utils.json_to_sheet(transformedData);
          XLSX.utils.book_append_sheet(wb, ws, '缺派PO计费单工单列表');
        }

        // 处理err_list数据
        if (data.err_list && data.err_list.length > 0) {
          // 转换数据，添加中文表头
          const transformedData = data.err_list.map((item) => {
            const newItem = {};
            Object.keys(headerMap).forEach((key) => {
              if (item[key] !== undefined) {
                // 特殊处理某些字段的显示
                if (key === 'manualCheckStatus') {
                  newItem[headerMap[key]] =
                    item[key] === '1' ? '正常' : item[key] === '0' ? '异常' : '-';
                } else if (key === 'autoCheckStatus') {
                  newItem[headerMap[key]] =
                    item[key] === '1' ? '正常' : item[key] === '0' ? '异常' : '-';
                } else if (key === 'confirm_result') {
                  newItem[headerMap[key]] =
                    item[key] === '1' ? '正常' : item[key] === '0' ? '异常' : '-';
                } else {
                  newItem[headerMap[key]] = item[key] || '-';
                }
              }
            });
            return newItem;
          });

          const ws = XLSX.utils.json_to_sheet(transformedData);
          XLSX.utils.book_append_sheet(wb, ws, '异常工单列表');
        }
        let fileNames = '';
        if (data.lact_ticket_list.length > 0) {
          fileNames = `账单核对导出_${data.lact_ticket_list[0].Month}.xlsx`;
        }
        if (data.err_list.length > 0) {
          fileNames = `账单核对导出_${data.err_list[0].Month}.xlsx`;
        }
        // 生成文件名
        const currentDate = new Date().toISOString().split('T')[0];
        const fileName = fileNames;
        // 导出文件
        XLSX.writeFile(wb, fileName);

        this.$message.success('导出Excel成功');
      } catch (error) {
        console.error('导出Excel失败:', error);
        this.$message.error('导出Excel失败：' + error.message);
      }
    },

    handleReset() {
      this.searchForm = {
        TicketId: '',
        completeTime: [],
        isDelayCause: '',
        orderNo: '',
        it_po_opTicketid: '',
        cost_confirm_opTicketid: '',
        billState: '',
        engineerName: '',
        createTime: [],
        autoCheckStatus: '',
        manualCheckStatus: '',
        confirm_result: '',
      };
      // const endDate = new Date();
      // const startDate = new Date();
      // startDate.setMonth(startDate.getMonth() - 1);
      // this.searchForm.completeTime = [
      //   this.$moment(startDate).format('YYYY-MM-DD'),
      //   this.$moment(endDate).format('YYYY-MM-DD'),
      // ];
      this.handleDateChange(this.searchForm.completeTime);
      this.currentPage = 1;
      this.fetchFaultData();
    },
    openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
      this.visibleColumns = this.columns.filter((column) =>
        this.selectedColumns.includes(column.prop)
      );
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((column) => column.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns = [...this.defaultSelectedColumns];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchFaultData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchFaultData();
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    async handleExport() {
      this.exportLoading = true;
      try {
        if (this.selectedRows.length === 0) {
          // 导出全部数据
          this.loading = true;
          const response = await getNetworkBillListAll({
            ...Object.fromEntries(
              Object.entries(this.searchForm).filter(
                ([_, value]) => value !== '' && value !== null && value !== undefined
              )
            ),
            pageSize: this.total || 9999999, // 确保获取所有数据
            currentPage: 1,
          });

          if (response.data) {
            this.loading = false;
            const allData = response.data.data.list || [];
            // 转换数据格式，确保与表格显示一致
            const worksheetData = allData.map((row) => {
              const rowData = {};
              this.visibleColumns.forEach((column) => {
                if (column.prop !== 'operation') {
                  // 排除操作列
                  let value = row[column.prop];
                  // 特殊字段处理，与表格显示保持一致
                  if (column.prop === 'isDelayCause') {
                    value = row[column.prop] === true ? '是' : '否';
                  }
                  rowData[column.label] = value || '-';
                }
              });
              return rowData;
            });

            // 创建工作簿和工作表
            const worksheet = XLSX.utils.json_to_sheet(worksheetData);

            // 设置列宽
            const colWidths = {};
            this.visibleColumns.forEach((column, index) => {
              const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
              colWidths[XLSX.utils.encode_col(index)] = { wch: width };
            });
            worksheet['!cols'] = Object.values(colWidths);

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, '账单核对');

            // 生成文件名
            const timestamp = this.$moment().format('YYYYMMDDHHmmss');
            // 提取所有不重复的月份
            const months = [...new Set(allData.map((item) => item.Month))].sort();
            const monthStr = months.join('_');
            const filename = `账单核对_${monthStr}.xlsx`;
            // 导出文件
            XLSX.writeFile(workbook, filename);
            this.$message.success('导出成功');
          }
        } else {
          // 导出选中数据的逻辑保持不变
          const worksheetData = this.selectedRows.map((row) => {
            const rowData = {};
            this.visibleColumns.forEach((column) => {
              if (column.prop !== 'operation') {
                // 排除操作列
                let value = row[column.prop];
                if (column.prop === 'isDelayCause') {
                  value = row[column.prop] === true ? '是' : '否';
                }
                rowData[column.label] = value || '-';
              }
            });
            return rowData;
          });

          const worksheet = XLSX.utils.json_to_sheet(worksheetData);

          const colWidths = {};
          this.visibleColumns.forEach((column, index) => {
            const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
            colWidths[XLSX.utils.encode_col(index)] = { wch: width };
          });
          worksheet['!cols'] = Object.values(colWidths);

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, '账单核对');

          const timestamp = this.$moment().format('YYYYMMDDHHmmss');
          // 提取所有不重复的月份
          const months = [...new Set(this.selectedRows.map((item) => item.Month))].sort();
          const monthStr = months.join('_');
          const filename = `账单核对_${monthStr}.xlsx`;

          XLSX.writeFile(workbook, filename);
          this.$message.success('导出成功');
        }
      } catch (error) {
        console.error('导出错误:', error);
        this.$message.error('导出失败，请重试');
      } finally {
        this.exportLoading = false;
        this.loading = false;
      }
    },
  },
  computed: {
    exportButtonText() {
      return this.selectedRows.length > 0 ? `导出已选(${this.selectedRows.length})` : '导出全部';
    },
  },
  watch: {
    selectedColumns(val) {
      this.selectAll = val.length === this.columns.length;
      this.isIndeterminate = val.length > 0 && val.length < this.columns.length;
    },
  },
};
</script>

<style scoped>
.confirm-popover {
  text-align: center;
}

.popover-content {
  display: flex;
  justify-content: space-around;
  padding: 10px;
}

.popover-content .el-button {
  margin: 0 5px;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}

.search-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.search-form {
  width: 100%;
}

.search-button {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 13px;
}

/* 调整表单项间距 */
.el-form-item {
  margin-bottom: 18px;
  display: flex;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  position: relative;
}

.box-card {
  margin-bottom: 20px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
}

.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}

.columns-dialog {
  margin-top: 0 !important;
  position: absolute !important;
  margin-left: 0 !important;
  top: 100% !important;
  left: 0 !important;
  transform: none !important;
}

.el-dialog__wrapper.columns-dialog {
  position: absolute !important;
  overflow: visible !important;
}

.checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.checkbox-item {
  margin-right: 0;
  white-space: normal;
  word-break: break-all;
  line-height: 1.2;
  padding: 5px 0;
}

.dialog-footer {
  text-align: right;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.dialog-footer .el-button+.el-button {
  margin-left: 8px;
}

/* 修改日期选择器宽度 */
::v-deep .el-date-editor.el-input__inner,
.el-date-editor--daterange.el-input__inner {
  width: 100% !important;
}

::v-deep .el-range-editor.el-input__inner {
  width: 100% !important;
}

::v-deep .el-date-editor .el-range-input {
  width: 66% !important;
}

::v-deep .el-range-editor--small .el-range-input {
  font-size: 12px !important;
}

/* 统一下拉框和输入框宽度 */
::v-deep .el-select,
.el-input {
  width: 100% !important;
}

::v-deep .el-form-item__content {
  width: calc(100% - 10px) !important;
}

/* PO单号链接样式 */
::v-deep .el-table a {
  color: #409eff;
  text-decoration: none;
  font-weight: 500;
}

::v-deep .el-table a:hover {
  color: #66b1ff;
  text-decoration: underline;
  font-weight: 500;
}
</style>
